import React from "react";
import { Link } from "react-router-dom";
import Image from '../../../Partials/Image/index'

const Header = () => {
  return (
    <>
      <header id="header" className="transition">
        <nav className="navbar navbar-expand-lg navbar-light bg-white">
          <Link className="navbar-brand mr-auto" to="/">
            <Image className={"img-fluid"} image={"/images/logo.svg"} />
          </Link>
          <button
            className="navbar-toggler navbar-toggler-right ml-lg-0"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse justify-content-center nav-center"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/about ">
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/services">
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/project-list">
                  Projects
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/journal">
                  Journal
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Contact
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/shop">
                  Shop
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/shop">
                  Cart (1)
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;
